import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c6029d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex align-items-stretch flex-shrink-0 gap-6 gap-lg-0" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex align-items-center ms-1 ms-lg-3"
}
const _hoisted_3 = { class: "d-flex ms-8" }
const _hoisted_4 = { class: "" }
const _hoisted_5 = {
  href: "/profile/billing",
  class: "btn btn-primary fw-semibold me-2"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-right-square-fill" }, null, -1))
const _hoisted_7 = { class: "d-flex align-items-center ms-1 ms-lg-3" }
const _hoisted_8 = ["title"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-compass" }, null, -1))
const _hoisted_10 = { class: "d-none d-md-inline" }
const _hoisted_11 = {
  class: "d-flex align-items-center ms-1 ms-lg-3",
  id: "kt_header_notifications_toggle"
}
const _hoisted_12 = { class: "btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px p-lg-8" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-sm btn-active-color-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-translate fs-2" })
], -1))
const _hoisted_14 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-semibold w-200px py-3",
  "data-kt-menu": "true",
  style: {}
}
const _hoisted_15 = { class: "menu-item px-3 border-bottom" }
const _hoisted_16 = { class: "menu-content text-muted pb-2 px-3 fs-7 text-uppercase" }
const _hoisted_17 = { class: "text-primary" }
const _hoisted_18 = { class: "menu-item px-3 mt-1" }
const _hoisted_19 = { class: "menu-item px-3" }
const _hoisted_20 = { class: "menu-item px-3" }
const _hoisted_21 = {
  class: "d-flex align-items-center ms-lg-3",
  id: "kt_header_notifications_toggle"
}
const _hoisted_22 = ["title"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-bell fs-2" }, null, -1))
const _hoisted_24 = {
  key: 0,
  class: "badge badge-circle badge-primary position-absolute",
  style: {"top":"6px","right":"6px","width":"8px","height":"8px","min-width":"8px","padding":"0","z-index":"10"}
}
const _hoisted_25 = { class: "d-flex align-items-center ms-1 ms-lg-3" }
const _hoisted_26 = ["title"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-hdd-network",
  style: {"font-size":"2rem"}
}, null, -1))
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = {
  class: "d-flex align-items-center ms-1 ms-lg-3",
  id: "kt_header_user_menu_toggle"
}
const _hoisted_30 = {
  class: "cursor-pointer symbol symbol-30px symbol-md-40px",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-attach": "parent",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "bottom"
}
const _hoisted_31 = ["src", "title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CareerCompassModal = _resolveComponent("CareerCompassModal")!
  const _component_KTNotifications = _resolveComponent("KTNotifications")!
  const _component_KTQuickLinksMenu = _resolveComponent("KTQuickLinksMenu")!
  const _component_KTUserMenu = _resolveComponent("KTUserMenu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.currentUser.features && _ctx.currentUser.features.length <= 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, [
              _createElementVNode("a", _hoisted_5, [
                _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.button_member`)) + " ", 1),
                _hoisted_6
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("button", {
        type: "button",
        class: "compass-btn",
        title: _ctx.$t(`${_ctx.currentLanguage}.career_compass.button_title`),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.compassOpen = true))
      }, [
        _hoisted_9,
        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.career_compass.title`)), 1)
      ], 8, _hoisted_8),
      _createVNode(_component_CareerCompassModal, {
        open: _ctx.compassOpen,
        onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.compassOpen = false))
      }, null, 8, ["open"])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.language.language`)) + ": ", 1),
              _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.language.lang`)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("a", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeLanguage('en'))),
              class: "menu-link px-3"
            }, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.language.en`)), 1)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("a", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeLanguage('pt'))),
              class: "menu-link px-3"
            }, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.language.pt`)), 1)
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("a", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeLanguage('es'))),
              class: "menu-link px-3"
            }, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.language.es`)), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("div", {
        class: "btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px p-lg-8 position-relative",
        "data-kt-menu-trigger": "click",
        "data-kt-menu-attach": "parent",
        "data-kt-menu-placement": "bottom-end",
        "data-kt-menu-flip": "bottom",
        title: _ctx.$t(`${_ctx.currentLanguage}.top_bar.notifications`)
      }, [
        _hoisted_23,
        (_ctx.notifications_count)
          ? (_openBlock(), _createElementBlock("span", _hoisted_24))
          : _createCommentVNode("", true)
      ], 8, _hoisted_22),
      _createVNode(_component_KTNotifications)
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("div", {
        class: "btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px p-lg-8",
        "data-kt-menu-trigger": "click",
        "data-kt-menu-attach": "parent",
        "data-kt-menu-placement": "bottom-end",
        "data-kt-menu-flip": "bottom",
        title: _ctx.$t(`${_ctx.currentLanguage}.top_bar.connection_vpn`)
      }, _hoisted_28, 8, _hoisted_26),
      _createVNode(_component_KTQuickLinksMenu)
    ]),
    _createElementVNode("div", _hoisted_29, [
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("img", {
          src: _ctx.currentUser.avatar || '/media/avatars/blank.png',
          title: _ctx.currentUser.nick || 'Hackername'
        }, null, 8, _hoisted_31)
      ]),
      _createVNode(_component_KTUserMenu)
    ])
  ]))
}